import React, { useContext, useEffect, useMemo } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";

import { Button } from "primereact/button";
import { Password } from "primereact/password";

import EntityFormPage from "../../../../components/EntityFormPage/EntityFormPage";
import { ToastContext } from "../../../../App";
import {
  useGetUserListQuery,
  useUpdateUserPasswordMutation,
} from "../../../../redux/services/user";
import getSubdomain from "../../../../utils/getSubdomain";

import * as styles from "../ChefManagement.module.css";

const LIST_PATH = "/app/manager/chefs";

function ChefPasswordPage() {
  const showToast = useContext(ToastContext);
  const navigate = useNavigate();
  const { id } = useParams();

  const { data: chefList } = useGetUserListQuery(getSubdomain());

  const chef = useMemo(
    () => chefList?.find((c) => String(c.id) === String(id)),
    [chefList, id],
  );

  const { control, handleSubmit } = useForm({
    defaultValues: { password: "" },
  });

  const [
    updateChefPassword,
    {
      isSuccess: isUpdateChefPasswordSuccess,
      isError: isUpdateChefPasswordError,
      error: updateChefPasswordError,
    },
  ] = useUpdateUserPasswordMutation();

  useEffect(() => {
    if (isUpdateChefPasswordSuccess) {
      showToast("success", "Chef", "Chef password updated!");
      navigate(LIST_PATH);
    }
  }, [isUpdateChefPasswordSuccess]);

  useEffect(() => {
    if (isUpdateChefPasswordError) {
      showToast(
        "error",
        updateChefPasswordError?.status,
        updateChefPasswordError?.data?.message ||
          (updateChefPasswordError?.data?.errors && "Incorrect data"),
      );
    }
  }, [isUpdateChefPasswordError]);

  const onSavePassword = (data) => {
    updateChefPassword({
      subdomain: getSubdomain(),
      payload: { id: Number(id), password: data.password },
    });
  };

  const title = chef?.username
    ? `Edit Chef Password — ${chef.username}`
    : "Edit Chef Password";

  return (
    <EntityFormPage
      title={title}
      backTo={LIST_PATH}
      footer={
        <Button
          label="Save"
          type="submit"
          className={`p-button-success ${styles.saveBtn}`}
          onClick={handleSubmit(onSavePassword)}
        />
      }
    >
      <form onSubmit={handleSubmit(onSavePassword)}>
        <Controller
          name="password"
          control={control}
          render={({ field }) => (
            <div className="field">
              <label>Password</label>
              <Password
                {...field}
                className={`w-full ${styles.password}`}
                inputClassName="w-full"
                placeholder="Password"
                toggleMask
                feedback={false}
              />
            </div>
          )}
        />
        <button type="submit" hidden />
      </form>
    </EntityFormPage>
  );
}

export default ChefPasswordPage;
